export type MatriculaParseResult = {
  matriculas: string[]
  sourceRows: number
  duplicates: number
  invalid: string[]
}

export function normalizeMatricula(value: unknown) {
  const raw = String(value ?? '').trim()
  if (!raw) return ''
  const withoutDecimal = raw.endsWith('.0') ? raw.slice(0, -2) : raw
  const compact = withoutDecimal.replace(/\s+/g, '')
  return /^\d+$/.test(compact) ? compact : ''
}

export function parseMatriculaColumn(rows: unknown[][]): MatriculaParseResult {
  const unique = new Set<string>()
  const invalid: string[] = []
  let duplicates = 0
  let sourceRows = 0
  let firstNonEmptyHandled = false

  for (const row of rows) {
    const raw = String(row?.[0] ?? '').trim()
    if (!raw) continue

    if (!firstNonEmptyHandled) {
      firstNonEmptyHandled = true
      const header = raw
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase('pt-BR')
      if (header.includes('matricula')) continue
    }

    sourceRows += 1
    const normalized = normalizeMatricula(raw)
    if (!normalized) {
      invalid.push(raw)
      continue
    }
    if (unique.has(normalized)) {
      duplicates += 1
      continue
    }
    unique.add(normalized)
  }

  return {
    matriculas: [...unique],
    sourceRows,
    duplicates,
    invalid,
  }
}

export async function checksumMatriculas(matriculas: string[]) {
  const canonical = [...matriculas].sort().join('\n')
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(canonical))
  return [...new Uint8Array(digest)].map((part) => part.toString(16).padStart(2, '0')).join('')
}
